export { c as constructGoogleImageParams, g as getImageUrlFromGoogleUserContent } from './image-b1bfb7c2.js';
export { f as formatCurrency } from './number-e3270bb3.js';
export { c as calculateTimeDelta } from './time-41e6541a.js';
export { g as getTrackingData } from './tracking-3282e302.js';
import { PromotionApplyOnEnum } from '@teko/types/ecommerce';
import { t } from './i18n.es.js';
export { c as convertMegaMenu } from './megaMenu-0ccc961e.js';
import 'i18next';

const convertStatusToProductTag = (status) => {
    switch (status === null || status === void 0 ? void 0 : status.sellingCode) {
        case 'hang_trung_bay':
            return { content: t('Hàng trưng bày'), variant: 'default' };
        case 'hang_dat_truoc':
            return { content: t('Hàng đặt trước'), variant: 'default' };
        case 'ngung_kinh_doanh':
            return { content: t('Ngừng kinh doanh'), variant: 'default' };
        case 'hang_khac':
            return { content: t('Hàng quà tặng'), variant: 'default' };
        default:
            return undefined;
    }
};
const convertProductCard = (product) => {
    const { productInfo, promotions, totalAvailable, prices, flashSales, status, } = product;
    let hasGift = false;
    promotions.forEach((el) => {
        var _a;
        if (el.applyOn === PromotionApplyOnEnum.product &&
            (((_a = el === null || el === void 0 ? void 0 : el.benefit) === null || _a === void 0 ? void 0 : _a.gifts) || []).length)
            hasGift = true;
    });
    const productPrice = prices === null || prices === void 0 ? void 0 : prices[0];
    let flashSale;
    let isFlashSale = false;
    const flSale = flashSales[0];
    if (flashSales.length) {
        isFlashSale = true;
        flashSale = {
            endAt: new Date(parseInt(flSale.endTimestampSec) * 1000),
            text: flSale.totalCount - flSale.usedCount < 5
                ? t('Còn lại {{var0}}', {
                    var0: flSale.totalCount - flSale.usedCount,
                })
                : t('Đã bán {{FlSaleUsedCount}}', {
                    FlSaleUsedCount: flSale.usedCount,
                }),
            discountPercent: Math.round(productPrice.discountPercent),
        };
    }
    let titleTag = null;
    const isOutOfStock = product.totalAvailable === 0;
    if (isOutOfStock) {
        titleTag = {
            variant: 'link',
            content: t('Hàng sắp về'),
        };
    }
    else if (!(productPrice === null || productPrice === void 0 ? void 0 : productPrice.latestPrice)) {
        titleTag = {
            variant: 'pending',
            content: t('Liên hệ'),
        };
    }
    const infoTags = [];
    if (status && convertStatusToProductTag(status)) {
        infoTags.push(convertStatusToProductTag(status));
    }
    const stockQuantity = totalAvailable === null
        ? 1000
        : isFlashSale
            ? Math.min(flSale.totalCount - flSale.usedCount, totalAvailable)
            : totalAvailable;
    return {
        sku: productInfo.sku,
        name: productInfo.name,
        imageUrl: productInfo.imageUrl,
        price: productPrice
            ? {
                latestPrice: +productPrice.latestPrice,
                supplierRetailPrice: productPrice.discountPercent
                    ? +productPrice.supplierRetailPrice
                    : undefined,
                discountPercent: productPrice.discountPercent && !isFlashSale
                    ? `-${productPrice.discountPercent}%`
                    : undefined,
                discountAmount: +productPrice.discountAmount > 0 && !isFlashSale
                    ? +productPrice.discountAmount
                    : undefined,
            }
            : undefined,
        stockQuantity,
        stockQuantityText: !isFlashSale && !isOutOfStock && stockQuantity < 5
            ? t('Còn {{stockQuantity}} sản phẩm', { stockQuantity: stockQuantity })
            : undefined,
        warranty: {
            months: productInfo.warranty.months,
        },
        flashSale,
        hasGift,
        titleTag,
        infoTags,
    };
};

const getComponentSize = (isMobile) => {
    return isMobile ? 's' : 'm';
};

export { convertProductCard, getComponentSize };
